export default __webpack_public_path__ + "static/media/Leaders_IMG-Crystal.7eb460b5.png";